module.exports = __webpack_public_path__ + "static/img/border_bg01.3d85371d.png";